import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderProps } from 'react-oidc-context';

import { env } from '@/app/conf/env';

/**
 * Configuration for OIDC (OpenID Connect) authentication.
 */
export const oidcConfig: AuthProviderProps = {
  authority: env.OIDC_AUTHORITY,
  client_id: env.OIDC_CLIENT_ID,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  scope: 'openid profile email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // once the signin callback is complete, drop the search params
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  extraQueryParams: {
    audience: 'https://client-api.bettertime.dev/'
  }
};
